/*Copyright (c) 2023. Honeywell International, Inc. All rights reserved.
This file contains trade secrets of Honeywell International, Inc. 
No part may be reproduced or transmitted in any form by any means or for any purpose without the express written permission of Honeywell. */
import React from "react";
import { Tooltip } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import "./AcceptTerms.scss";
import { Checkbox } from "@forge/common";
import { useTranslation } from '@scuf/localization';
import { localeKeyMap } from '../../localization/keys';

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

/**
 *
 * @summery to render accept terms and conditions check box
 */
interface IProps {
  onTermsAccept: (event: any) => void;
  isTermsAccepted?: boolean;
  isFormFilled?: boolean;
  text?: string;
}
const AcceptTerms = (props: IProps) => {
  const [t] = useTranslation();
  const checkboxColor =
    !props.isTermsAccepted && props.isFormFilled ? "#EE3426" : "#F0F0F0";

  return (
    <Tooltip
      title={t(localeKeyMap.userConsentAgreement)}
      arrow
      open={!props.isTermsAccepted && props.isFormFilled}
      placement="bottom-start"
    >
      <div className="accept-terms">
        <Checkbox
          key={`terms-checkbox-${props.isTermsAccepted}`}
          checked={props.isTermsAccepted}
          data-testid="my-checkbox"
          id="terms"
          name="terms"
          onChange={(event: any) =>
            props.onTermsAccept && props.onTermsAccept(event)
          }
          value="terms"
          className="terms-label"
          error={!props.isTermsAccepted && props.isFormFilled}
        >
          <label className="label-text">
            {props.text
              ? props.text
              : t(localeKeyMap.acceptTerms)}
          </label>
        </Checkbox>
      </div>
    </Tooltip>
  );
};

export default AcceptTerms;
